/*
 * Feed
 */
if($('#feedBlog').length){
  var $this = $('#feedBlog');
  var href = $this.data("url");
  $.get(href, function(data) {
    //$this.append(data);
  });
}